/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_TitleInputs */

const zh_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享`)
};

const en_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const es_share_title = /** @type {(inputs: Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Share_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const share_title = /** @type {((inputs?: Share_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_title(inputs)
	if (locale === "en") return en_share_title(inputs)
	return es_share_title(inputs)
});